module.exports = __webpack_public_path__ + "static/media/home-sale.33c981a9.jpg";